import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { getErrorMessage } from "helpers";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseRedirectWhen404ErrorProps = {
	mainErrorHandler?: () => void;
	otherErrorHandler?: () => void;
	extraStatuses?: number[];
};

const useRedirectWhen404Error = ({
	mainErrorHandler,
	otherErrorHandler,
	extraStatuses = [],
}: UseRedirectWhen404ErrorProps = {}) => {
	const history = useHistory();
	const dispatch = useDispatch();

	const redirectWhen404Error = useCallback(
		(error: { [key: string]: any }) => {
			const errorStatus = error?.status || error?.error?.status;

			if ([...extraStatuses, 404].includes(errorStatus)) {
				mainErrorHandler?.();

				history.push(`${history.location.pathname}/error`);
			} else {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error as ErrorResponse),
					}),
				);

				otherErrorHandler?.();
			}
		},
		[extraStatuses, mainErrorHandler, otherErrorHandler, history, dispatch],
	);

	return { redirectWhen404Error };
};

export { useRedirectWhen404Error };
